// 未選択
export const itemNoSelection: ListItem[] = [{ id: undefined, name: '未選択' }];

// 物件情報：契約期間（選択肢マスタ管理対象外）
export const propertyContractTerm: ListItem[] = [
  { id: 10, name: '1年間' },
  { id: 20, name: '2年間' },
  { id: 30, name: '3年間' },
  { id: 40, name: '4年間' },
  { id: 50, name: '5年間' },
  { id: 60, name: '6年間' },
  { id: 70, name: '7年間' },
  { id: 80, name: '8年間' },
  { id: 90, name: '9年間' },
  { id: 100, name: '10年間' },
  { id: 110, name: '10年間以上' }
];

export const getContractTermLabel = (id: number) => {
  for (let i = 0; i < propertyContractTerm.length; i++) {
    if (propertyContractTerm[i].id === id) {
      return propertyContractTerm[i].name;
    }
  }
  return '';
};

// 物件検索条件選択肢：賃料
export const searchParamRentMin: ListItem[] = [
  { id: undefined, name: '下限なし' },
  { id: 100000, name: '10万円' },
  { id: 200000, name: '20万円' },
  { id: 300000, name: '30万円' },
  { id: 400000, name: '40万円' },
  { id: 500000, name: '50万円' },
  { id: 600000, name: '60万円' },
  { id: 700000, name: '70万円' },
  { id: 800000, name: '80万円' },
  { id: 900000, name: '90万円' },
  { id: 1000000, name: '100万円' },
  { id: 1500000, name: '150万円' },
  { id: 2000000, name: '200万円' },
  { id: 3000000, name: '300万円' },
  { id: 4000000, name: '400万円' },
  { id: 5000000, name: '500万円' }
];

// 物件検索条件選択肢：賃料(上限)
export const searchParamRentMax: ListItem[] = [
  { id: 100000, name: '10万円' },
  { id: 200000, name: '20万円' },
  { id: 300000, name: '30万円' },
  { id: 400000, name: '40万円' },
  { id: 500000, name: '50万円' },
  { id: 600000, name: '60万円' },
  { id: 700000, name: '70万円' },
  { id: 800000, name: '80万円' },
  { id: 900000, name: '90万円' },
  { id: 1000000, name: '100万円' },
  { id: 1500000, name: '150万円' },
  { id: 2000000, name: '200万円' },
  { id: 3000000, name: '300万円' },
  { id: 4000000, name: '400万円' },
  { id: 5000000, name: '500万円' },
  { id: undefined, name: '上限なし' }
];

// 物件検索条件選択肢：土地面積(下限)
export const searchParamTsuboMin: ListItem[] = [
  { id: undefined, name: '下限なし' },
  { id: 10, name: '10坪' },
  { id: 15, name: '15坪' },
  { id: 20, name: '20坪' },
  { id: 25, name: '25坪' },
  { id: 30, name: '30坪' },
  { id: 35, name: '35坪' },
  { id: 40, name: '40坪' },
  { id: 45, name: '45坪' },
  { id: 50, name: '50坪' },
  { id: 60, name: '60坪' },
  { id: 70, name: '70坪' },
  { id: 80, name: '80坪' },
  { id: 90, name: '90坪' },
  { id: 100, name: '100坪' },
  { id: 150, name: '150坪' },
  { id: 200, name: '200坪' },
  { id: 250, name: '250坪' }
];

// 物件検索条件選択肢：土地面積(上限)
export const searchParamTsuboMax: ListItem[] = [
  { id: 10, name: '10坪' },
  { id: 15, name: '15坪' },
  { id: 20, name: '20坪' },
  { id: 25, name: '25坪' },
  { id: 30, name: '30坪' },
  { id: 35, name: '35坪' },
  { id: 40, name: '40坪' },
  { id: 45, name: '45坪' },
  { id: 50, name: '50坪' },
  { id: 60, name: '60坪' },
  { id: 70, name: '70坪' },
  { id: 80, name: '80坪' },
  { id: 90, name: '90坪' },
  { id: 100, name: '100坪' },
  { id: 150, name: '150坪' },
  { id: 200, name: '200坪' },
  { id: 250, name: '250坪' },
  { id: undefined, name: '上限なし' }
];

// 物件検索条件選択肢：最寄り駅まで徒歩分数
export const searchParamAccessToStation: ListItem[] = [
  { id: undefined, name: '選択なし' },
  { id: 1, name: '1分以内' },
  { id: 3, name: '3分以内' },
  { id: 5, name: '5分以内' },
  { id: 10, name: '10分以内' },
  { id: 15, name: '15分以内' },
  { id: 9999, name: '16分以上' }
];

// 検索条件：階数
export const propertyFloorSearch: ListItem[] = [
  { id: undefined, name: '未選択' },
  { id: -1, name: '地下' },
  { id: 1, name: '1階' },
  { id: 2, name: '2階' },
  { id: 3, name: '3階以上' },
  { id: 4, name: '複数階一括(1階を含む)' },
  { id: 5, name: '複数階一括(1階を含まない)' }
];

// 物件情報：階数
export const propertyFloor: ListItem[] = [...Array(55)].map((_, i) => {
  const story = i >= 5 ? i - 4 : i - 5;
  const name = story < 0 ? `地下${Math.abs(story)}階` : `${story}階`;
  return { id: story, name: name };
});

export const getPropertyFloor = (id: number | undefined) => {
  if (id === undefined) {
    return '';
  }
  return getNameVal(propertyFloor, id);
};

// 物件情報＆検索条件：ビルの階数
export const propertyStories: ListItem[] = [...Array(50)].map((_, i) => {
  const story = i + 1;
  return { id: story, name: `${story.toString()}階` };
});

// 物件情報：駐車場
export const parkingSpace = [
  { id: 0, name: '未登録' },
  { id: 1, name: 'あり' },
  { id: 2, name: 'なし' }
];

export const getParkingSpaceLabel = (id: number | undefined) => {
  if (id === undefined) {
    return '';
  }
  return getNameVal(parkingSpace, id);
};

// 物件情報登録/編集
export const publicRangeList = [
  {
    id: 1,
    name: '全公開'
  },
  {
    id: 2,
    name: '会員にのみ公開'
  },
  {
    id: 3,
    name: '有料会員にのみ公開'
  }
];

const getNameVal = (data: ListItem[], id: number) => {
  for (let i = 0; i < data.length; i++) {
    if (data[i].id === id) {
      return data[i].name;
    }
  }
  return '';
};

export const gender = [
  { id: 1, name: '男性' },
  { id: 2, name: '女性' }
];

export const inputGender = [
  { id: 1901, name: '男' },
  { id: 1902, name: '女' },
  { id: 1903, name: 'その他' }
];

export const available = [
  { id: 2001, name: 'はい' },
  { id: 2002, name: 'いいえ' }
];

export const inputDinerExperience = [
  { id: 6901, name: '調理業務' },
  { id: 6902, name: '接客業務' },
  { id: 6903, name: '店舗運営業務（店長など）' },
  { id: 6904, name: 'その他（本部、店舗開発等）' }
];

export const inputOpnSchedTime = [
  { id: 7001, name: '半年以内' },
  { id: 7002, name: '１年以内' },
  { id: 7003, name: '２年～３年以内' },
  { id: 7004, name: '４年～５年以内' },
  { id: 7005, name: '６年～１０年以内' },
  { id: 7006, name: '１０年より先' },
  { id: 7007, name: '出店予定なし' }
];

export const include = [
  { id: undefined, name: '未選択' },
  { id: 1, name: '含む' },
  { id: 2, name: '含まない' }
];

// 仮実装 st
export const week = [
  { id: 1, name: '月' },
  { id: 2, name: '火' },
  { id: 3, name: '水' },
  { id: 4, name: '木' },
  { id: 5, name: '金' },
  { id: 6, name: '土' },
  { id: 7, name: '日' }
];
// 仮実装 end
export const publicSetting = [
  { id: 0, name: '非公開' },
  { id: 1, name: '公開' }
];

export const mailSetting = [
  { flg: false, name: 'OFF' },
  { flg: true, name: 'ON' }
];

/**
 * @type selectItem
 * labelとvalueのペア
 * @param {string} label label(key)
 * @param {number | undefined} value (value)
 *
 * @remarks select、checkboxにて使用の想定
 */
export type selectItem = {
  label: string;
  value: number | undefined;
};

/**
 * @type selectStationItem
 * labelとvalueのペア
 * @param {string} label label(key)
 * @param {number | undefined} value (value)
 * @param {number | undefined} rosenNum (value)
 *
 * @remarks メール配信設定checkbox用
 */
export type selectStationItem = {
  label: string;
  value: number | undefined;
  rosenNum: number | undefined;
};

/**
 * @type ListItem
 * idとnameのペア
 * @param {number | undefined} id id(key)
 * @param {string} name name(value)
 */
export type ListItem = {
  id: number | undefined;
  name: string;
  explanation?: string;
};

export type ListItemBoolean = {
  flg: boolean | undefined;
  name: string;
};

export const defaultObjValue = { value: undefined, label: '選択してください' };

export const footerLinkList = [
  { label: 'よくある質問', path: '/faq', blank: false },
  { label: 'お問い合わせ', path: '/contact', blank: false },
  { label: '利用規約', path: '/term', blank: false },
  { label: 'プライバシーポリシー', path: '/privacy', blank: false },
  {
    label: '運営会社概要',
    path: 'https://g-fac.jp/company/',
    blank: true
  }
];

export const isPublic = [
  { id: '1', name: '公開' },
  { id: '2', name: '非公開' }
];
// ListItem型の定義
export type cognitoExceptionType = {
  [key: string]: string;
};
export const COGNITO_EXCEPTION: cognitoExceptionType = {
  InternalErrorException: 'エラーが発生しました。',
  InvalidLambdaResponseException: 'エラーが発生しました。',
  UnexpectedLambdaException: 'エラーが発生しました。',
  ResourceNotFoundException: 'エラーが発生しました。',
  TooManyRequestsException: '名前エラーが発生しました。',
  CodeDeliveryFailureException: 'エラーが発生しました。',
  InvalidEmailRoleAccessPolicyException: 'エラーが発生しました。',
  InvalidParameterException: '入力内容に誤りがあります。',
  InvalidPasswordException: '入力内容に誤りがあります。',
  NotAuthorizedException: 'メールアドレスまたはパスワードに誤りがあります。',
  UsernameExistsException: '既に登録されているメールアドレスです。',
  UserNotConfirmedException: 'メールアドレスの認証が完了していません',
  PasswordResetException: 'エラーが発生しました。',
  CodeMismatchException: '入力内容に誤りがあります。',
  LimitExceededException: '試行回数の上限を超えました。しばらく経ってからお試しください。',
  ExpiredCodeException: '検証コードの有効期限が切れています。',
  UserNotFoundException: 'メールアドレスまたはパスワードが違います',
  TypeError: 'ログインに失敗しました',
  UserLambdaValidationException: 'メールアドレスの認証が完了していません'
};

export const dayOfWeekList = [
  { id: 1, name: '月曜日' },
  { id: 2, name: '火曜日' },
  { id: 3, name: '水曜日' },
  { id: 4, name: '木曜日' },
  { id: 5, name: '金曜日' },
  { id: 6, name: '土曜日' },
  { id: 0, name: '日曜日' },
  { id: 7, name: '祝日' }
];

export const timeList = () => {
  const retData = [] as ListItem[];
  for (let index = 0; index < 24; index++) {
    retData.push({ id: index, name: String(index) + ':00' });
  }
  return retData;
};

// fileListItemの定義
export type fileListItem = {
  id: string;
  url: string;
  fileName: string;
  fileComment: string;
  isThumbnail: boolean;
  isMadori: boolean;
};

// ファイル種別の定義
export const fileType = {
  // image/jpg       : jpg, jpeg, jpe, jfif, pjpeg, pjp
  // image/png       : png
  // image/gif       : gif
  image: {
    accept: 'image/jpeg, image/png, image/gif',
    extension: ['jpg', 'jpeg', 'jpe', 'jfif', 'pjpeg', 'pjp', 'png', 'gif']
  },
  document: {
    accept: '.xlsx, .pdf',
    extension: ['xlsx', 'pdf']
  },
  any: {
    accept: '*',
    extension: []
  }
};

export const INITIAL_MAIL_CHECK: selectItem[] = [{ label: 'お知らせメール配信を登録する', value: 1 }];

// 共通モーダル用スタイル
export const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0',
    borderRadius: '15px'
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.6)',
    zIndex: 100
  }
};

export type numberType = number | undefined;

export const windowSize = {
  sp: 428,
  pc: 1230
};

// コラムリンク
export const columnInfo = [
  {
    id: 'aaa',
    imageSrc: '/column/CT0001.png',
    title: '集客効果を最大化するTikTokのうまい活用術',
    description:
      '集客効果を狙った販促を考えるとき、X（旧 Twitter）や Instagram などの SNS は今や欠かせない存在となってきています。',
    link: '/ct0001'
  },
  {
    id: 'bbb',
    imageSrc: '/column/CT0002.png',
    title: 'インバウンド集客を成功させる６つのポイント',
    description:
      'インバウンド需要が急速に回復しています。2023 年の訪日外国人旅行者数は推計 2507 万人（ 日本政府観光局）で、これはコロナ禍直前だった 2019 年の約 8 割の水準です。',
    link: '/ct0002'
  },
  {
    id: 'ccc',
    imageSrc: '/column/CT0003.png',
    title: '話題の商業施設にも続々オープン！　今、立ち飲み業態の訳',
    description:
      '今のトレンドは、ずばり立ち飲み業態です。これはコロナ禍で変化した人の流れや、外食店の絶対数の減少など、',
    link: '/ct0003'
  },
  {
    id: 'eee',
    imageSrc: '/column/CT0005.png',
    title: '「進化系専門店」がリードするおにぎりブーム最前線',
    description:
      'ここ 1、2 年、全国各地でおにぎり専門店がオープンし、おにぎりブームの様相を呈しています。特に首都圏では、',
    link: '/ct0005'
  }
];

export const settingMail = [
  { id: 1, name: 'OFF' },
  { id: 2, name: 'ON' }
];
